import personalDomains from './data/personalDomains'

const EMAIL_REGEX = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/

export default function validateEmail(email) {
  if (!email) return false
  if (email.length > 256) return false
  if (!EMAIL_REGEX.test(email)) return false

  // Further checking of some things regex can't handle
  const [username, domain] = email.split('@')

  const lowerCaseDomain = domain.toLowerCase()
  const isPersonalDomain = personalDomains.some(personalDomain => lowerCaseDomain.includes(personalDomain))
  if (isPersonalDomain) return false
  if (username.length > 64) return false

  const domainParts = domain.split('.')
  return !domainParts.some(part => part.length > 63)
}
